/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VersionInfo } from '../../models/version-info';

export interface ApiV0ConfigurationVersionInfoGet$Plain$Params {
}

export function apiV0ConfigurationVersionInfoGet$Plain(http: HttpClient, rootUrl: string, params?: ApiV0ConfigurationVersionInfoGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<VersionInfo>> {
  const rb = new RequestBuilder(rootUrl, apiV0ConfigurationVersionInfoGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VersionInfo>;
    })
  );
}

apiV0ConfigurationVersionInfoGet$Plain.PATH = '/api/v0/configuration/versionInfo';
